const lengthConfig = {
    bannerMessage: 1000,
    description: 4000,
    noteForModerator: 2000,
    suggest: 35,
    chatName: 100,
    smartHomeName: 100,
    secondaryTitle: 60,
    rsyPlatformId: 128,
} as const;

export default lengthConfig;
